import { useTopMenu } from '@/widgets/TopMenu/hooks/useTopMenu'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { SearchResultType } from '@/types/search/searchResultType'
import { RawLink } from '@/shared/ui/RawLink'
import { useVODStore } from '@/shared/store'
import {
    selectSetSearchItemDetails,
    selectResetItemDetails,
} from '@/shared/store/storeSelectors/vodSelectors'

interface IVodSearchItem {
    item: SearchResultType
}

export const VodSearchItem = ({ item }: IVodSearchItem) => {
    const { title, posterUrl } = item
    const setSearchItemDetails = useVODStore(selectSetSearchItemDetails)
    const resetItemDetails = useVODStore(selectResetItemDetails)
    const { handleVodClick } = useTopMenu()

    const handleSearchItemClick = () => {
        handleVodClick(true)
        setSearchItemDetails(item)
        resetItemDetails()
    }

    return (
        <RawLink
            to="/vod"
            onClick={handleSearchItemClick}
            dataTestId="SearchVodItemLink">
            <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                data-testid="SearchVodItem">
                <LazyLoadImage
                    alt={item.title || 'image'}
                    src={posterUrl}
                    height="100px"
                    width="100px"
                    style={{
                        objectFit: 'cover',
                    }}
                />
                <Typography variant="subtitle1" mt="8px">
                    {title}
                </Typography>
            </Box>
        </RawLink>
    )
}
